// @flow
import {
	connectWebActions,
	connectWebComponents,
	autoTitleLinksWithBlankTarget,
} from 'fg-frontend';
import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from './components/CookiesPolicy';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
import '../../resources/bootstrap/js/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy();
phoneLink();



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/configureWeb.js